import { RestClient } from '@/api/rest-client'
import { Source } from '@/api/model/source'

export class SourceClient extends RestClient<Source> {
    collectionName = 'sources'
    parseData = Source.fromData

    protected handleError(error: any) {
        throw error
    }
}
